<template>
    <div class="wrapper">
        <div class="content">
            <section class="contractSignersForm">
                <header>
                    <h4>Osoby upoważnione do podpisania umowy zgodnie z reprezentacją</h4>
                    <div class="icon" title="Infomacje dotyczące podawanych osób" @click="showPopup(0)">
                        <i class="material-icons">info</i>
                    </div>
                </header>
                <div class="data" v-if="haveAccount == 1 && contractSignersList.length != 0">
                    <h6>Wybierz osoby podpisujące umowę</h6>
                    <ul class="companies">
                        <li
                            v-for="(person, index) in contractSignersList" 
                            :key="'contract' + index" 
                            @click="pickContractPerson(person)"
                            :class="{ disabled: person.picked }">
                            {{person.name}} {{person.surname}} 
                            <!-- {{person.identity_card}} -->
                        </li>
                    </ul>
                </div>
                <div class="data-info">
                    <p v-if="!fullValidation && contractSigners.length < 1">
                        Podaj przynajmniej jedną osobę
                    </p>
                </div>
                <div class="data">
                    <div v-for="(person, index) in contractSigners" :key="'a' + index">
                        <div class="input-header">
                            <h6>Osoba nr {{ index + 1 }}</h6>
                            <i class="material-icons" title="Usuń osobę" @click="removeContractPerson(index)">delete</i>
                        </div>
                        <div class="input-container">
                            <header>
                                <h6 v-if="person.name">Imię</h6>
                            </header>
                            <div class="input-box">
                                <input type="text" class="data" :class="{ error: validContractSignersValues[index][0].value == 1 }" placeholder="Imię*" v-model="person.name" @blur="storeArrayElementInLocalStore(person.name, index, 'name', 'contractSigners', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validContractSignersValues[index][0].value == 1">close</i>
                            </div>
                            <p v-if="validContractSignersValues[index][0].value == 1 || validContractSignersValues[index][0].value == 1">{{ validContractSignersValues[index][0].text }}</p>
                        </div>
                        <div class="input-container">
                            <header>
                                <h6 v-if="person.surname">Nazwisko</h6>
                            </header>
                            <div class="input-box">
                                <input type="text" class="data" :class="{ error: validContractSignersValues[index][1].value == 1 }" placeholder="Nazwisko*" v-model="person.surname" @blur="storeArrayElementInLocalStore(person.surname, index, 'surname', 'contractSigners', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validContractSignersValues[index][1].value == 1">close</i>
                            </div>
                            <p v-if="validContractSignersValues[index][1].value == 1 || validContractSignersValues[index][1].value == 1">{{ validContractSignersValues[index][1].text }}</p>
                        </div>
                        <!-- <div class="input-container">
                            <header>
                                <h6 v-if="person.id && person.identity_card_type == 1">Pesel</h6>
                                <h6 v-if="person.id && person.identity_card_type == 2">Numer paszportu</h6>
                            </header>
                            <div class="input-box" v-if="person.identity_card_type == 1">
                                <input type="number" class="data" :class="{ error: validContractSignersValues[index][2].value == 1 }" @keydown="preventNumberInput" placeholder="PESEL*" v-model="person.id" @blur="storeArrayElementInLocalStore(person.id, index, 'id', 'contractSigners', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validContractSignersValues[index][2].value == 1">close</i>
                            </div>
                            <div class="input-box" v-if="person.identity_card_type == 2">
                                <input type="text" class="data" :class="{ error: validContractSignersValues[index][2].value == 1 }" placeholder="Numer paszportu*" v-model="person.id" @blur="storeArrayElementInLocalStore(person.id, index, 'id', 'contractSigners', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validContractSignersValues[index][2].value == 1">close</i>
                            </div>
                            <div class="input-container" v-if="!person.disabled">
                                <div class="input-checkbox">
                                    <div class="checkbox" @click="changePersonPeselType(person.identity_card_type, index, 'contractSigners'), storeArrayElementInLocalStore(person.identity_card_type, index, 'identity_card_type', 'contractSigners', 'formData')">
                                        <i class="material-icons" v-if="person.identity_card_type == 2">done</i>
                                    </div>
                                    <p>Nie mam numeru pesel</p>
                                </div>                            
                            </div>                            
                            <p v-if="validContractSignersValues[index][2].value == 1 || validContractSignersValues[index][2].value == 1">{{ validContractSignersValues[index][2].text }}</p>
                        </div> -->
                        <div class="select-container">
                            <header>
                                <h6>Stanowisko</h6>
                            </header>
                            <div class="select-box">
                                <div 
                                    class="select-component-container" 
                                    :class="{ 
                                        'select-component-container other': person.position === 'inne',
                                        'select-component-container other-selected': person.disabled === true 
                                    }"
                                    >
                                    <Select 
                                        v-if="!person.disabled"
                                        :options="positions"
                                        :default="person.position === 'inne' ? 'inne' : (person.position ? person.position : 'Wybierz stanowisko')"
                                        @input="selectPosition($event, index)"
                                    />
                                </div>
                                <input 
                                    type="text" 
                                    class="data position" 
                                    :class="{ 
                                        error: validContractSignersValues[index][3].value == 1, 
                                    }" 
                                    placeholder="Stanowisko*" 
                                    v-if="person.disabled && person.position === 'inne'" v-model="person.otherPosition" 
                                    @blur="storeArrayElementInLocalStore(person.otherPosition, index, 'otherPosition', 'contractSigners', 'formData')" 
                                    :disabled="person.disabled"
                                >
                                <input 
                                    type="text" 
                                    class="data position" 
                                    :class="{ 
                                        error: validContractSignersValues[index][3].value == 1, 
                                    }" 
                                    placeholder="Stanowisko*" 
                                    v-if="person.disabled && person.position !== 'inne'" 
                                    v-model="person.position" 
                                    @blur="storeArrayElementInLocalStore(person.otherPosition, index, 'otherPosition', 'contractSigners', 'formData')" 
                                    :disabled="person.disabled"
                                >
                                <input 
                                    type="text" 
                                    class="data position" 
                                    :class="{ 
                                        error: validContractSignersValues[index][3].value == 1, 
                                    }" 
                                    placeholder="Stanowisko*" 
                                    v-if="person.position === 'inne' && !person.disabled" 
                                    v-model="person.otherPosition" 
                                    @blur="storeArrayElementInLocalStore(person.otherPosition, index, 'otherPosition', 'contractSigners', 'formData')" 
                                    :disabled="person.disabled"
                                >
                            </div>
                            <p v-if="validContractSignersValues[index][3].value == 1 || validContractSignersValues[index][3].value == 1">{{ validContractSignersValues[index][3].text }}</p>
                        </div>
                    </div>
                    <h6 v-if="contractSigners.length == 0 && contractSignersList.length == 0">Dodaj osobę podpisującą umowę</h6>
                    <div class="peopleButtons">
                        <button class="default small reverse" v-if="(contractSigners.length < 6 && haveAccount == 0) || (contractSigners.length < 6 && haveAccount == 1)" @click="addContractPerson()">
                            <span v-if="contractSigners.length == 0">Dodaj osobę</span>
                            <span v-else>Dodaj kolejną osobę osobę</span>
                        </button>
                    </div>
                </div>
            </section>
            <section class="correspondenceDataForm">
                <header>
                    <h4>Dane do korespondencji</h4>
                    <div class="icon" title="Infomacje dotyczące podawanych danych" @click="showPopup(1)">
                        <i class="material-icons">info</i>
                    </div>
                </header>
                <div class="data">
                    <h6>Adres</h6>
                    <div class="input-container">
                        <header>
                            <h6 v-if="correspondenceAddress.city">Miasto</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCorrespondenceAddressValues[0].value == 1 }" placeholder="Miasto*" v-model="correspondenceAddress.city" @blur="storeObjectInLocalStore(correspondenceAddress.city, 'city', 'correspondenceAddress', 'formData')" :disabled="correspondenceAddress.disabled">
                            <i class="material-icons" v-if="validCorrespondenceAddressValues[0].value == 1">close</i>
                        </div>
                        <p v-if="validCorrespondenceAddressValues[0].value == 1 || validCorrespondenceAddressValues[0].value == 1">{{ validCorrespondenceAddressValues[0].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="correspondenceAddress.street">Ulica</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCorrespondenceAddressValues[1].value == 1 }" placeholder="Ulica*" v-model="correspondenceAddress.street" @blur="storeObjectInLocalStore(correspondenceAddress.street, 'street', 'correspondenceAddress', 'formData')" :disabled="correspondenceAddress.disabled">
                            <i class="material-icons" v-if="validCorrespondenceAddressValues[1].value == 1">close</i>
                        </div>
                        <p v-if="validCorrespondenceAddressValues[1].value == 1 || validCorrespondenceAddressValues[1].value == 1">{{ validCorrespondenceAddressValues[1].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="correspondenceAddress.houseNumber">Numer domu/mieszkania</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCorrespondenceAddressValues[2].value == 1 }" placeholder="Numer domu/mieszkania*" v-model="correspondenceAddress.houseNumber" @blur="storeObjectInLocalStore(correspondenceAddress.houseNumber, 'houseNumber', 'correspondenceAddress', 'formData')" :disabled="correspondenceAddress.disabled">
                            <i class="material-icons" v-if="validCorrespondenceAddressValues[2].value == 1">close</i>
                        </div>
                        <p v-if="validCorrespondenceAddressValues[2].value == 1 || validCorrespondenceAddressValues[2].value == 1">{{ validCorrespondenceAddressValues[2].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="correspondenceAddress.postCode">Kod pocztowy</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCorrespondenceAddressValues[3].value == 1 }" placeholder="Kod pocztowy*" v-model="correspondenceAddress.postCode" @blur="storeObjectInLocalStore(correspondenceAddress.postCode, 'postCode', 'correspondenceAddress', 'formData')" :disabled="correspondenceAddress.disabled">
                            <i class="material-icons" v-if="validCorrespondenceAddressValues[3].value == 1">close</i>
                        </div>
                        <p v-if="validCorrespondenceAddressValues[3].value == 1 || validCorrespondenceAddressValues[3].value == 1">{{ validCorrespondenceAddressValues[3].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="correspondenceAddress.comments">Dodatkowe informacje</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" maxlength="100" placeholder="Dodatkowe uwagi" v-model="correspondenceAddress.comments" @blur="storeObjectInLocalStore(correspondenceAddress.comments, 'comments', 'correspondenceAddress', 'formData')" :disabled="correspondenceAddress.disabled">
                        </div>
                    </div>
                    <div v-if="haveAccount == 1 && correspondenceNumberList.length != 0">
                        <h6>Wybierz numery do korespondencji</h6>
                        <ul class="companies">
                            <li 
                                v-for="(number, index) in correspondenceNumberList" 
                                :key="'number' + index"
                                @click="pickCorrespondenceNumber(number)"
                                :class="{ disabled: number.picked }">
                                {{number.phone}}
                            </li>
                        </ul>
                    </div>
                    <div class="data-info">
                        <p v-if="!fullValidation && correspondenceNumber.length < 1">
                            Podaj przynajmniej jeden numer
                        </p>
                    </div>
                    <div>
                        <div v-for="(number, index) in correspondenceNumber" :key="'b' + index">
                            <div class="input-header">
                                <h6>Telefon nr {{ index + 1 }}</h6>
                                <i class="material-icons" title="Usuń numer telefonu" @click="removeCorrespondenceNumber(index)">delete</i>
                            </div>
                            <div class="input-container">
                                <div class="input-box">
                                    <input type="number" class="data" :class="{ error: validCorrespondenceNumberValues[index].value == 1 }" placeholder="Numer telefonu*" v-model="number.number" @blur="storeArrayElementInLocalStore(number.number, index, 'number', 'correspondenceNumber', 'formData')" :disabled="number.disabled">
                                    <i class="material-icons" v-if="validCorrespondenceNumberValues[index].value == 1">close</i>
                                </div>
                                <p v-if="validCorrespondenceNumberValues[index].value == 1 || validCorrespondenceNumberValues[index].value == 1">{{ validCorrespondenceNumberValues[index].text }}</p>
                            </div>
                        </div>
                        <h6 v-if="correspondenceNumber.length == 0 && correspondenceNumberList.length == 0">Dodaj numer telefonu</h6>
                        <div class="peopleButtons">
                            <button class="default small reverse" v-if="(correspondenceNumber.length < 6 && haveAccount == 0) || (correspondenceNumber.length < 6 && haveAccount == 1)" @click="addCorrespondenceNumber()">
                                <span v-if="correspondenceNumber.length == 0">Dodaj numer</span>
                                <span v-else>Dodaj kolejny numer</span>
                            </button>
                        </div>
                    </div>
                    <div v-if="haveAccount == 1 && correspondenceEmailList.length != 0">
                        <h6>Wybierz e-maile do korespondencji</h6>
                        <ul class="companies">
                            <li 
                                v-for="(email, index) in correspondenceEmailList" 
                                :key="'email' + index" 
                                @click="pickCorrespondenceEmail(email)"
                                :class="{ disabled: email.picked }">
                                {{email.email}}
                            </li>
                        </ul>
                    </div>
                    <div class="data-info">
                        <p v-if="!fullValidation && correspondenceEmail.length < 1">
                            Podaj przynajmniej jeden adres e-mail
                        </p>
                    </div>
                    <div>
                        <div  v-for="(email, index) in correspondenceEmail" :key="'c' + index">
                            <div class="input-header">
                                <h6>Adres e-mail nr {{ index + 1 }}</h6>
                                <i class="material-icons" title="Usuń adres email" @click="removeCorrespondenceEmail(index)">delete</i>
                            </div>
                            <div class="input-container">
                                <div class="input-box">
                                    <input type="email" class="data" :class="{ error: validCorrespondenceEmailValues[index].value == 1 }" placeholder="E-mail*" v-model="email.email" @blur="storeArrayElementInLocalStore(email.email, index, 'email', 'correspondenceEmail', 'formData')" :disabled="email.disabled">
                                    <i class="material-icons" v-if="validCorrespondenceEmailValues[index].value == 1">close</i>
                                </div>
                                <p v-if="validCorrespondenceEmailValues[index].value == 1 || validCorrespondenceEmailValues[index].value == 1">{{ validCorrespondenceEmailValues[index].text }}</p>
                            </div>
                        </div>
                        <h6 v-if="correspondenceEmail.length == 0 && correspondenceEmailList.length == 0">Dodaj adres e-mail</h6>
                        <div class="peopleButtons">
                            <button class="default small reverse" v-if="(correspondenceEmail.length < 6 && haveAccount == 0) || (correspondenceEmail.length < 6 && haveAccount == 1)" @click="addCorrespondenceEmail()">
                                <span v-if="correspondenceEmail.length == 0">Dodaj adres e-mail</span>
                                <span v-else>Dodaj kolejny adres e-mail</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <section class="correspondencePeopleForm">
                <header>
                    <h4>Osoby upoważnione do odbioru korespondencji</h4>
                    <div class="icon" title="Infomacje dotyczące podawanych osób" @click="showPopup(2)">
                        <i class="material-icons">info</i>
                    </div>
                </header>
                <div class="data" v-if="haveAccount == 1 && correspondencePeopleList.length != 0">
                    <h6>Wybierz osoby</h6>
                    <ul class="companies">
                        <li 
                            v-for="(person, index) in correspondencePeopleList" 
                            :key="'person' + index" 
                            @click="pickCorrespondencePerson(person)"
                            :class="{ disabled: person.picked }">
                            {{person.name}} {{person.surname}} {{person.identity_card}}
                        </li>
                    </ul>
                </div>
                <div class="data">
                    <div v-for="(person, index) in correspondencePeople" :key="'d' + index">
                        <div class="input-header">
                                <h6>Osoba nr {{ index + 1 }}</h6>
                                <div class="input-header-buttons">
                                    <div class="select-container rewrite-person" v-if="!person.disabled && getSignersToCorrespondence.length != 0">
                                        <div class="select-box">
                                            <PersonSelect
                                                :peopleList = "getSignersToCorrespondence"
                                                :personIndex = "index"
                                                :default = "person"
                                                @input = "pickSignerToCorrespondence"
                                            />
                                        </div>
                                    </div>
                                    <i class="material-icons" title="Usuń osobę" @click="removeCorrespondencePerson(index)">delete</i>
                                </div>
                            </div>
                        <div class="input-container">
                            <header>
                                <h6 v-if="person.name">Imię</h6>
                            </header>
                            <div class="input-box">
                                <input type="text" class="data" :class="{ error: validCorrespondencePeopleValues[index][0].value == 1 }" placeholder="Imię*" v-model="person.name" @blur="storeArrayElementInLocalStore(person.name, index, 'name', 'correspondencePeople', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validCorrespondencePeopleValues[index][0].value == 1">close</i>
                            </div>
                            <p v-if="validCorrespondencePeopleValues[index][0].value == 1 || validCorrespondencePeopleValues[index][0].value == 1">{{ validCorrespondencePeopleValues[index][0].text }}</p>
                        </div>
                        <div class="input-container">
                            <header>
                                <h6 v-if="person.surname">Nazwisko</h6>
                            </header>
                            <div class="input-box">
                                <input type="text" class="data" :class="{ error: validCorrespondencePeopleValues[index][1].value == 1 }" placeholder="Nazwisko*" v-model="person.surname" @blur="storeArrayElementInLocalStore(person.surname, index, 'surname', 'correspondencePeople', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validCorrespondencePeopleValues[index][1].value == 1">close</i>
                            </div>
                            <p v-if="validCorrespondencePeopleValues[index][1].value == 1 || validCorrespondencePeopleValues[index][1].value == 1">{{ validCorrespondencePeopleValues[index][1].text }}</p>
                        </div>
                        <div class="input-container">
                            <header>
                                <h6 v-if="person.id && person.identity_card_type == 1">Pesel</h6>
                                <h6 v-if="person.id && person.identity_card_type == 2">Numer paszportu</h6>
                            </header>
                            <div class="input-box" v-if="person.identity_card_type == 1">
                                <input type="number" class="data" :class="{ error: validCorrespondencePeopleValues[index][2].value == 1 }" @keydown="preventNumberInput" placeholder="PESEL*" v-model="person.id" @blur="storeArrayElementInLocalStore(person.id, index, 'id', 'correspondencePeople', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validCorrespondencePeopleValues[index][2].value == 1">close</i>
                            </div>
                            <div class="input-box" v-if="person.identity_card_type == 2">
                                <input type="text" class="data" :class="{ error: validCorrespondencePeopleValues[index][2].value == 1 }" placeholder="Numer paszportu*" v-model="person.id" @blur="storeArrayElementInLocalStore(person.id, index, 'id', 'correspondencePeople', 'formData')" :disabled="person.disabled">
                                <i class="material-icons" v-if="validCorrespondencePeopleValues[index][2].value == 1">close</i>
                            </div>
                            <div class="input-container" v-if="!person.disabled">
                                <div class="input-checkbox">
                                    <div class="checkbox" @click="changePersonPeselType(person.identity_card_type, index, 'correspondencePeople'), storeArrayElementInLocalStore(person.identity_card_type, index, 'identity_card_type', 'correspondencePeople', 'formData')">
                                        <i class="material-icons" v-if="person.identity_card_type == 2">done</i>
                                    </div>
                                    <p>Nie mam numeru pesel</p>
                                </div>                            
                            </div>   
                            <p v-if="validCorrespondencePeopleValues[index][2].value == 1 || validCorrespondencePeopleValues[index][2].value == 1">{{ validCorrespondencePeopleValues[index][2].text }}</p>
                        </div>
                    </div>
                    <h6 v-if="correspondencePeople.length == 0 && correspondencePeopleList.length == 0">Dodaj osobę do odbioru korespondencji</h6>
                    <div class="peopleButtons">
                        <button class="default small reverse" v-if="(correspondencePeople.length < 6 && haveAccount == 0) || (correspondencePeople.length < 6 && haveAccount == 1)" @click="addCorrespondencePerson()">
                            <span v-if="correspondencePeople.length == 0">Dodaj osobę</span>
                            <span v-else>Dodaj kolejną osobę osobę</span>
                        </button>
                    </div>
                </div>
                <div class="data-info">
                    <p v-if="!fullValidation && correspondencePeople.length < 1">
                        Podaj przynajmniej jedną osobę
                    </p>
                </div>
            </section>
        </div>
        <order-nav forwardString="Kontynuuj" @goBack="goBack" :backPushingWay="backPushingWay" @goForward="goForward" :forwardPushingWay="forwardPushingWay" :forwardDisabled="true" @validation="validateFields()"></order-nav>
    </div>
</template>

<script>
    import localStorageManager from '../functions/localStorageManager';
    import validation from '../functions/validation';
    import OrderNav from '@/components/OrderNav.vue';
    import PersonSelect from '../components/PersonSelect';
    import Select from '../components/Select';
    import InfoPopup from '../components/InfoPopup';

    export default {
        name: 'Step2AdditionalData',
        components: {
            OrderNav,
            PersonSelect,
            Select,
            InfoPopup,
        },
        data() {
            return {
                infoTexts: [
                    'Wpisz wszystkie osoby, które reprezentują firmę zgodnie z ewidencją CEIDG lub rejestrem KRS.',
                    'Podaj adres, na który będziemy przesyłać twoją korespondecję.',
                    'Wpisz wszystkie osoby, które będą upoważnione do odbioru korespondencji.',
                ],
                fullValidation: true,
                haveAccount: '',
                positions: ['Właściciel', 'Wspólnik', 'Prezes zarządu', 'Wice prezes', 'Członek zarządu', 'Pełnomocnik', 'inne'],
                forwardPushingWay: 1,
                backPushingWay: 1,
                contractSigners: [],
                contractSignersList: [],
                validContractSignersValues: [],
                correspondenceAddress: {
                    city: '',
                    street: '',
                    houseNumber: '',
                    postCode: '',
                    comments: '',
                },
                validCorrespondenceAddressValues: new Array(4).fill(0).map(() => ({ value: 0, text: 'Podana wartość jest nieprawidłowa', })),
                correspondenceNumber: [],
                correspondenceNumberList: [],
                validCorrespondenceNumberValues: [],
                correspondenceEmail: [],
                correspondenceEmailList: [],
                validCorrespondenceEmailValues: [],
                correspondencePeople: [],
                correspondencePeopleList: [],
                validCorrespondencePeopleValues: [],
                signerToCorrespondence: Array(6).fill('Wybierz osobę'),
            }
        },
        methods: {
            changePersonPeselType(peselType, index, variableName) {
                if(peselType == 2) {
                    this[variableName][index].identity_card_type = 1;
                } else {
                    this[variableName][index].identity_card_type = 2;

                };
            },
            addContractPerson() {
                if(this.contractSigners.length < 6) {
                    const payload = { name: '', surname: '', id: '', idPlaceholder: 'Pesel*', position: '', otherPosition: '', disabled: false, identity_card_type: 1, picked: false };
                    const validationPayload = [
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    ];
                    this.contractSigners.push(payload);
                    this.validContractSignersValues.push(validationPayload);
                    this.storeArrayInLocalStore(payload, 'contractSigners', 'formData');
                    this.storeArrayInLocalStore(validationPayload, 'validContractSignersValues', 'formData');
                }
            },
            removeContractPerson(index) {
                this.contractSignersList.forEach(person => {
                    if(person.id == this.contractSigners[index].id) {
                        person.picked = false;
                        return;
                    }
                });
                this.contractSigners.splice(index, 1);
                this.validContractSignersValues.splice(index, 1);
                this.removeFromArrayInLocalStore('contractSigners', 'formData', index);
                this.removeFromArrayInLocalStore('validContractSignersValues', 'formData', index);
            },
            pickContractPerson(person) {
                if(this.contractSigners.length < 6) {
                    if(!person.picked) {
                        person.picked = true;
                        const positions = ['Właściciel', 'Wspólnik', 'Prezes zarządu', 'Wice prezes', 'Członek zarządu'];
                        const payload = { name: person.name, surname: person.surname, id: person.id, disabled: true, identity_card_type: person.identity_card_type, picked: person.picked };
                        if(person.position in positions) {
                            payload.position = person.position;
                            payload.otherPosition = '';
                        } else {
                            payload.position = 'inne';
                            payload.otherPosition = person.position;
                        };
                        const validationPayload = [
                            { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                            { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                            { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                            { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        ];
                        this.contractSigners.push(payload);
                        this.validContractSignersValues.push(validationPayload);
                        this.storeArrayInLocalStore(payload, 'contractSigners', 'formData');
                        this.storeArrayInLocalStore(validationPayload, 'validContractSignersValues', 'formData');
                    }
                } else {
                    this.toggleAlert(0, 'Można dodać maksymalnie 6 osób');
                }
            },
            addCorrespondenceNumber() {
                if(this.correspondenceNumber.length < 6) {
                    const payload = { number: '', disabled: false, picked: false };
                    const validationPayload = { value: 0, text: 'Podana wartość jest nieprawidłowa', };
                    this.correspondenceNumber.push(payload);
                    this.validCorrespondenceNumberValues.push(validationPayload);
                    this.storeArrayInLocalStore(payload, 'correspondenceNumber', 'formData');
                    this.storeArrayInLocalStore(validationPayload, 'validCorrespondenceNumberValues', 'formData');
                }
            },
            removeCorrespondenceNumber(index) {
                this.correspondenceNumberList.forEach(number => {
                    if(number.phone == this.correspondenceNumber[index].number) {
                        number.picked = false;
                        return;
                    }
                });
                this.correspondenceNumber.splice(index, 1);
                this.validCorrespondenceNumberValues.splice(index, 1);
                this.removeFromArrayInLocalStore('correspondenceNumber', 'formData', index);
                this.removeFromArrayInLocalStore('validCorrespondenceNumberValues', 'formData', index);
            },
            pickCorrespondenceNumber(number) {
                if(this.correspondenceNumber.length < 6) {
                    if(!number.picked) {
                        number.picked = true;
                        const payload = { number: number.phone, disabled: true, picked: number.picked };
                        const validationPayload = { value: 0, text: 'Podana wartość jest nieprawidłowa', };
                        this.correspondenceNumber.push(payload);
                        this.validCorrespondenceNumberValues.push(validationPayload);
                        this.storeArrayInLocalStore(payload, 'correspondenceNumber', 'formData');
                        this.storeArrayInLocalStore(validationPayload, 'validCorrespondenceNumberValues', 'formData');
                    }
                } else {
                    this.toggleAlert(0, 'Można dodać maksymalnie 6 numerów');
                }
            },
            addCorrespondenceEmail() {
                if(this.correspondenceEmail.length < 6) {
                    const payload = { email: '', disabled: false, picked: false };
                    const validationPayload = { value: 0, text: 'Podana wartość jest nieprawidłowa', };
                    this.correspondenceEmail.push(payload);
                    this.validCorrespondenceEmailValues.push(validationPayload);
                    this.storeArrayInLocalStore(payload, 'correspondenceEmail', 'formData');
                    this.storeArrayInLocalStore(validationPayload, 'validCorrespondenceEmailValues', 'formData');
                }
            },
            removeCorrespondenceEmail(index) {
                this.correspondenceEmailList.forEach(email => {
                    if(email.email == this.correspondenceEmail[index].email) {
                        email.picked = false;
                        return;
                    }
                });
                this.correspondenceEmail.splice(index, 1);
                this.validCorrespondenceEmailValues.splice(index, 1);
                this.removeFromArrayInLocalStore('correspondenceEmail', 'formData', index);
                this.removeFromArrayInLocalStore('validCorrespondenceEmailValues', 'formData', index);
            },
            pickCorrespondenceEmail(email) {
                if(this.correspondenceEmail.length < 6) {
                    if(!email.picked) {
                        email.picked = true;
                        const payload = { email: email.email, disabled: true, picked: email.picked };
                        const validationPayload = { value: 0, text: 'Podana wartość jest nieprawidłowa', };
                        this.correspondenceEmail.push(payload);
                        this.validCorrespondenceEmailValues.push(validationPayload);
                        this.storeArrayInLocalStore(payload, 'correspondenceEmail', 'formData');
                        this.storeArrayInLocalStore(validationPayload, 'validCorrespondenceEmailValues', 'formData');
                    }
                } else {
                    this.toggleAlert(0, 'Można dodać maksymalnie 6 adresów e-mail');
                }
            },
            addCorrespondencePerson() {
                if(this.correspondencePeople.length < 6) {
                    const payload = { name: '', surname: '', id: '', idPlaceholder: 'Pesel*', disabled: false, identity_card_type: 1, picked: false };
                    const validationPayload = [
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    ];
                    this.correspondencePeople.push(payload);
                    this.validCorrespondencePeopleValues.push(validationPayload);
                    this.storeArrayInLocalStore(payload, 'correspondencePeople', 'formData');
                    this.storeArrayInLocalStore(validationPayload, 'validCorrespondencePeopleValues', 'formData');
                }
            },
            removeCorrespondencePerson(index) {
                this.correspondencePeopleList.forEach(person => {
                    if(person.identity_card == this.correspondencePeople[index].id) {
                        person.picked = false;
                        return;
                    }
                });
                this.correspondencePeople.splice(index, 1);
                this.validCorrespondencePeopleValues.splice(index, 1);
                this.removeFromArrayInLocalStore('correspondencePeople', 'formData', index);
                this.removeFromArrayInLocalStore('validCorrespondencePeopleValues', 'formData', index);
            },
            pickCorrespondencePerson(person) {
                if(this.correspondencePeople.length < 6) {
                    if(!person.picked) {
                        person.picked = true;
                        const payload = { name: person.name, surname: person.surname, id: person.identity_card, disabled: true, identity_card_type: person.identity_card_type, picked: person.picked };
                        const validationPayload = [
                            { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                            { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                            { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        ];
                        this.correspondencePeople.push(payload);
                        this.validCorrespondencePeopleValues.push(validationPayload);
                        this.storeArrayInLocalStore(payload, 'correspondencePeople', 'formData');
                        this.storeArrayInLocalStore(validationPayload, 'validCorrespondencePeopleValues', 'formData');
                    }
                } else {
                    this.toggleAlert(0, 'Można dodać maksymalnie 6 osób');
                }
            },
            selectPosition(position, index) {
                if(position != 'inne') {
                    this.$set(this.contractSigners[index], 'otherPosition', '');
                }
                this.$set(this.contractSigners[index], 'position', position);
                this.storeArrayElementInLocalStore(this.contractSigners[index].position, index, 'position', 'contractSigners', 'formData');
            },
            storeArrayInLocalStore(payload, valueName, objectName) {
                localStorageManager.storeArrayInLocalStore(payload, valueName, objectName);
            },
            storeArrayElementInLocalStore(value, index, key, valueName, objectName) {
                localStorageManager.storeArrayElementInLocalStore(value, index, key, valueName, objectName);
            },
            storeObjectInArrayInLocalStore(value, index, valueName, objectName) {
                localStorageManager.storeObjectInArrayInLocalStore(value, index, valueName, objectName);
            },
            storeInLocalStorage(value, valueName, objectName) {
                localStorageManager.storeInLocalStorage(value, valueName, objectName);
            },
            storeObjectInLocalStore(value, key, valueName, objectName) {
                localStorageManager.storeObjectInLocalStore(value, key, valueName, objectName);
            },
            removeFromArrayInLocalStore(valueName, objectName, index) {
                localStorageManager.removeFromArrayInLocalStore(valueName, objectName, index);
            },
            goBack() {
                this.$emit('goBack');
            },
            goForward() {
                this.$emit('goForward');
            },
            preventNumberInput(e) {
                if(e.keyCode == 69
                || e.keyCode == 107
                || e.keyCode == 109
                || e.keyCode == 110
                || e.keyCode == 187
                || e.keyCode == 188
                || e.keyCode == 189
                || e.keyCode == 190) {
                    e.preventDefault();
                }
            },
            pickSignerToCorrespondence(person, index) {
                this.correspondencePeople[index].name = person.name;
                this.correspondencePeople[index].surname = person.surname;
                this.correspondencePeople[index].id = person.id;
                this.correspondencePeople[index].idPlaceholder = person.idPlaceholder;
                this.correspondencePeople[index].identity_card_type = person.identity_card_type;
                this.correspondencePeople[index].disabled = person.disabled;
                this.storeObjectInArrayInLocalStore(this.correspondencePeople[index], index, 'correspondencePeople', 'formData');
            },
            async validateFields(){
                this.$store.commit('changeValidateStep', false);
                
                this.validateContractPersons();
                this.validateCorrespondenceAddress();
                this.validateCorrespondenceNumber();
                this.validateCorrespondenceEmail();
                this.validateCorrespondencePeople();

                if(this.validContractSignersValues.filter(element => element.filter(subelement => subelement.value == 1).length).length > 0
                || this.validCorrespondenceAddressValues.filter(element => element.value == 1).length > 0
                || this.validCorrespondenceNumberValues.filter(element => element.value == 1).length > 0
                || this.validCorrespondenceEmailValues.filter(element => element.value == 1).length > 0
                || this.validCorrespondencePeopleValues.filter(element => element.filter(subelement => subelement.value == 1).length).length > 0
                || this.contractSigners.length < 1
                || this.correspondenceEmail.length < 1
                || this.correspondencePeople.length < 1
                || this.correspondenceNumber.length < 1) {
                    this.$store.commit('changeValidateStep', false);
                    this.fullValidation = false;
                    this.toggleAlert(0, 'Poprawnie wypełnij pola');
                    return;
                } else {
                    this.$store.commit('changeValidateStep', true);
                    this.goForward();
                }
            },
            validateContractPersons() {
                let idCardAppearance = [];
                for(let i = 0; i < this.contractSigners.length; i++) {
                    this.validContractSignersValues[i][0] = validation.validateStringWithoutNumbers(this.contractSigners[i].name, this.validContractSignersValues[i][0], 50);
                    this.validContractSignersValues[i][1] = validation.validateStringWithoutNumbers(this.contractSigners[i].surname, this.validContractSignersValues[i][1], 50);
                    // if(this.contractSigners[i].identity_card_type == 2) {
                    //     this.validContractSignersValues[i][2] = validation.validatePassport(this.contractSigners[i].id, this.validContractSignersValues[i][2]);
                    // } else {
                    //     this.validContractSignersValues[i][2] = validation.validatePesel(this.contractSigners[i].id, this.validContractSignersValues[i][2]);
                    // };
                    if(this.contractSigners[i].position === 'inne') {
                        this.validContractSignersValues[i][3] = validation.validatePosition(this.contractSigners[i].otherPosition, this.validContractSignersValues[i][3]);
                    } else {
                        this.validContractSignersValues[i][3] = validation.validatePosition(this.contractSigners[i].position, this.validContractSignersValues[i][3]);
                    }
                    // if(idCardAppearance.includes(this.contractSigners[i].id)) {
                    //     this.validContractSignersValues[i][2].value = 1;
                    //     this.validContractSignersValues[i][2].text = 'Podana wartość została już przypisana innej osobie';
                    // } else {
                    //     idCardAppearance.push(this.contractSigners[i].id);
                    // }
                };
            },
            validateCorrespondenceAddress() {
                this.validCorrespondenceAddressValues[0] = validation.validateString(this.correspondenceAddress.city, this.validCorrespondenceAddressValues[0], 50);
                this.validCorrespondenceAddressValues[1] = validation.validateString(this.correspondenceAddress.street, this.validCorrespondenceAddressValues[1], 50);
                this.validCorrespondenceAddressValues[2] = validation.validateString(this.correspondenceAddress.houseNumber, this.validCorrespondenceAddressValues[2], 20);
                this.validCorrespondenceAddressValues[3] = validation.validatePostalCode(this.correspondenceAddress.postCode, this.validCorrespondenceAddressValues[3]);
            },
            validateCorrespondenceNumber() {
                let numberAppearance = [];
                for(let i = 0; i < this.correspondenceNumber.length; i++) {
                    this.validCorrespondenceNumberValues[i] = validation.validatePhoneNumber(this.correspondenceNumber[i].number, this.validCorrespondenceNumberValues[i]);
                    if(numberAppearance.includes(this.correspondenceNumber[i].number)) {
                        this.validCorrespondenceNumberValues[i].value = 1;
                        this.validCorrespondenceNumberValues[i].text = 'Numer został już podany wcześniej';
                    } else {
                        numberAppearance.push(this.correspondenceNumber[i].number);
                    }
                };
            },
            validateCorrespondenceEmail() {
                let emailAppearance = [];
                for(let i = 0; i < this.correspondenceEmail.length; i++) {
                    this.validCorrespondenceEmailValues[i] = validation.validateEmail(this.correspondenceEmail[i].email, this.validCorrespondenceEmailValues[i]);
                    if(emailAppearance.includes(this.correspondenceEmail[i].email)) {
                        this.validCorrespondenceEmailValues[i].value = 1;
                        this.validCorrespondenceEmailValues[i].text = 'Email został już podany wcześniej';
                    } else {
                        emailAppearance.push(this.correspondenceEmail[i].email);
                    }
                };
            },
            validateCorrespondencePeople() {
            let idCardAppearance = [];
                for(let i = 0; i < this.correspondencePeople.length; i++) {
                    this.validCorrespondencePeopleValues[i][0] = validation.validateStringWithoutNumbers(this.correspondencePeople[i].name, this.validCorrespondencePeopleValues[i][0], 50);
                    this.validCorrespondencePeopleValues[i][1] = validation.validateStringWithoutNumbers(this.correspondencePeople[i].surname, this.validCorrespondencePeopleValues[i][1], 50);
                    if(this.correspondencePeople[i].identity_card_type == 2) {
                        this.validCorrespondencePeopleValues[i][2] = validation.validatePassport(this.correspondencePeople[i].id, this.validCorrespondencePeopleValues[i][2]);
                    } else {
                        this.validCorrespondencePeopleValues[i][2] = validation.validatePesel(this.correspondencePeople[i].id, this.validCorrespondencePeopleValues[i][2]);
                    };
                    if(idCardAppearance.includes(this.correspondencePeople[i].id)) { 
                        this.validCorrespondencePeopleValues[i][2].value = 1;
                        this.validCorrespondencePeopleValues[i][2].text = 'Podana wartość została już przypisana innej osobie';
                    } else {
                        idCardAppearance.push(this.correspondencePeople[i].id);
                    };
                };
            },
            async getAdditionalData() {
                const formData = JSON.parse(localStorage.formData);
                const payload = { nip: formData.nip }
                await this.axios
                .get(this.api + 'company/addinfo', { params: payload })
                .then(response => {
                    if(response.data.status == 1) {
                        if(response.data.data.contractSigners.length > 0) {
                            this.contractSignersList = response.data.data.contractSigners;
                            if(formData.contractSigners) {
                                formData.contractSigners.forEach(person => {
                                    let index = this.contractSignersList.findIndex(element => element.id == person.id);
                                    if(index != -1) {
                                        this.contractSignersList[index].picked = true;
                                    }
                                });
                            }
                        }
                        if(response.data.data.correspondenceAddress && !formData.correspondenceAddress) {
                            this.correspondenceAddress = {
                                city: response.data.data.correspondenceAddress.city,
                                street: response.data.data.correspondenceAddress.street,
                                houseNumber: response.data.data.correspondenceAddress.number_house,
                                postCode: response.data.data.correspondenceAddress.post_code,
                                comments: response.data.data.correspondenceAddress.comment,
                            }
                            formData.correspondenceAddress = this.correspondenceAddress;
                        }
                        if(response.data.data.correspondenceNumber.length > 0) {
                            this.correspondenceNumberList = response.data.data.correspondenceNumber;
                            if(formData.correspondenceNumber) {
                                formData.correspondenceNumber.forEach(number => {
                                    let index = this.correspondenceNumberList.findIndex(element => element.phone == number.number);
                                    if(index != -1) {
                                        this.correspondenceNumberList[index].picked = true;
                                    }
                                });
                            }
                        }
                        if(response.data.data.correspondenceEmail.length > 0) {
                            this.correspondenceEmailList = response.data.data.correspondenceEmail;
                            if(formData.correspondenceEmail) {
                                formData.correspondenceEmail.forEach(email => {
                                    let index = this.correspondenceEmailList.findIndex(element => element.email == email.email);
                                    if(index != -1) {
                                        this.correspondenceEmailList[index].picked = true;
                                    }
                                });
                            }
                        }
                        if(response.data.data.correspondencePeople.length > 0) {
                            this.correspondencePeopleList = response.data.data.correspondencePeople;
                            if(formData.correspondencePeople) {
                                formData.correspondencePeople.forEach(person => {
                                    let index = this.correspondencePeopleList.findIndex(element => element.identity_card == person.id);
                                    if(index != -1) {
                                        this.correspondencePeopleList[index].picked = true;
                                    }
                                });
                            }
                        }
                        localStorage.setItem('formData', JSON.stringify(formData));
                    }
                });
            },
            toggleAlert(type, msg) {
                this.$store.commit('toggleAlert', {
                    visibility: 1,
                    type: type,
                    msg: msg
                });
            },
            showPopup(id) {
                this.$emit('showPopup', this.infoTexts[id]);
            }
        },
        computed: {
            isOrderNavDisabled() {
                var inputsElements = [];
                var emptyValues = [];

                this.contractSigners.forEach(person => {
                    inputsElements.push(person.name, person.surname, person.id, person.position);
                    if(person.position === "inne") {
                    inputsElements.push(person.otherPosition);
                    }
                });
                this.correspondenceNumber.forEach(number => {
                    inputsElements.push(number.number);
                });
                this.correspondenceEmail.forEach(email => {
                    inputsElements.push(email.email);
                });
                this.correspondencePeople.forEach(person => {
                    inputsElements.push(person.name, person.surname, person.id);
                });
                inputsElements.push(this.correspondenceAddress.city, this.correspondenceAddress.street, this.correspondenceAddress.houseNumber, this.correspondenceAddress.postCode);
                
                inputsElements.filter((element) => {
                    if(element === '') {
                        emptyValues.push(1);
                    } else {
                        emptyValues.push(0);
                    };
                });
                return emptyValues.reduce((a, b) => { return a + b });
            },
            api(){
                return this.$store.state.api;
            },
            getSignersToCorrespondence() {
                // let correspondencePeopleIds = this.correspondencePeople.map(person => { return person.id });
                // let correspondencePeopleListIds = this.correspondencePeopleList.map(person => { return person.identity_card });
                // return this.contractSigners.filter(person => {
                //     return (person.name && person.surname && person.id) && !correspondencePeopleListIds.includes(person.id) && !correspondencePeopleIds.includes(person.id);
                // });
                return this.contractSigners;
            },
        },
        watch: {
        },
        async created() {
            this.$store.commit('changeOrderNavDisable', false);
            var formData;
            if(localStorage.step2State !== undefined) {
                const step2State = JSON.parse(localStorage.step2State);
                Object.keys(step2State).forEach(key => {
                    if(this[key] == '' || this[key]) {
                        this[key] = step2State[key];
                    }
                });
            }
            if(this.haveAccount == 1) {
                await this.getAdditionalData();
            };
            if(localStorage.formData !== undefined) {
                formData = JSON.parse(localStorage.formData);
                Object.keys(formData).forEach(key => {
                    if(this[key] == '' || this[key]) {
                        this[key] = formData[key];
                    }
                });
            } else {
                formData = {};
            }
            if((this.haveAccount != 1 || this.contractSignersList.length == 0) && this.contractSigners.length == 0) {
                this.contractSigners = [{ name: '', surname: '', id: '', idPlaceholder: 'Pesel*', position: '', otherPosition: '', disabled: false, identity_card_type: 1, picked: false }];
                formData.contractSigners = this.contractSigners;
                this.validContractSignersValues = [
                    [
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', }
                    ]
                ];
                formData.validContractSignersValues = this.validContractSignersValues;
            }
            if((this.haveAccount != 1 || this.correspondenceNumberList.length == 0) && this.correspondenceNumber.length == 0) {
                this.correspondenceNumber = [{ number: '', disabled: false, picked: false }];
                formData.correspondenceNumber = this.correspondenceNumber;
                this.validCorrespondenceNumberValues = [
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', }
                ];
                formData.validCorrespondenceNumberValues = this.validCorrespondenceNumberValues;
            }
            if((this.haveAccount != 1 || this.correspondenceEmailList.length == 0) && this.correspondenceEmail.length == 0) {
                this.correspondenceEmail = [{ email: '', disabled: false, picked: false }];
                formData.correspondenceEmail = this.correspondenceEmail;
                this.validCorrespondenceEmailValues = [
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', }
                ];
                formData.validCorrespondenceEmailValues = this.validCorrespondenceEmailValues;
            }
            if((this.haveAccount != 1 || this.correspondencePeopleList.length == 0) && this.correspondencePeople.length == 0) {
                this.correspondencePeople = [{ name: '', surname: '', id: '', idPlaceholder: 'Pesel*', disabled: false, identity_card_type: 1, picked: false }];
                formData.correspondencePeople = this.correspondencePeople;
                this.validCorrespondencePeopleValues = [
                    [
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                        { value: 0, text: 'Podana wartość jest nieprawidłowa', }
                    ]
                ];
                formData.validCorrespondencePeopleValues = this.validCorrespondencePeopleValues;
            }
            localStorage.setItem('formData', JSON.stringify(formData));
        },
    }
</script>

<style lang="scss" scoped>
    .companies li.disabled {
        background-color:  #da4e01;
        color: white;
        cursor: default;
    }
</style>
